/*
 * @Author: ���� 371824572@qq.com
 * @Date: 2024-07-18 16:32:47
 * @LastEditors: ���� 371824572@qq.com
 * @LastEditTime: 2024-07-18 16:35:33
 * @FilePath: \rencaiban-xcx-adminnew\src\api\RecruitmentTemplate\RecruitmentTemplate.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import * as api from '../api';
import axios from 'axios';
// import router from '../routerManuaConfig'
import Vue from 'vue';
let base = api.BaseApiUrl;

//招考报名模板查询
export const PostSelectRecruitmentTemplate = params => {
    return axios.post(`${base}/api/RecruitmentRegistration/PostSelectRecruitmentTemplate`, params);
};
//招考报名模板详情查询
export const PostSelectRecruitmentTemplateDetail = params => {
    return axios.get(`${base}/api/RecruitmentRegistration/GetSelectRecruitmentTemplateDetail`, { params });
};
//招考报名模板添加
export const PostAddRecruitmentTemplate = params => {
    return axios.post(`${base}/api/RecruitmentRegistration/PostAddRecruitmentTemplate`, params);
};
//招考报名模板更新
export const PutRecruitmentTemplate = params => {
    return axios.put(`${base}/api/RecruitmentRegistration/PutRecruitmentTemplate`, params);
};
//删除
export const DeleteRecruitmentTemplate = params => {
    return axios.delete(`${base}/api/RecruitmentRegistration/DeleteRecruitmentTemplate`, { params: params });
};